import React, { Component, useEffect, useState } from 'react';
import ServiceRequestsView from './ServiceRequestsView';
import { getCurrency, getData, initOptionHeader } from '../../utils/common';
import NewServiceRequestController from './NewServiceRequestController';
import crmservices from '../../wsclient/';
import { connection } from '../../../portal.config';

function ServiceRequestsController(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [showNewServiceRequest, onShowNewServiceRequest] = useState(false);

    const [service_requests, setServiceRequests] = useState([]);

    const [requestDetail, setRequestDetail] = useState(null);
    const [showDetail, onShowDetail] = useState(false);
    const [files, setFiles] = useState([]);
    const [urlFile, setUrlFile] = useState(null);

    useEffect(() => {
        getListServiceRequests();
    }, [])
    const getListServiceRequests = async () => {
        onShowLoading(true);
        let result = await crmservices.config.getListServiceRequests();
        if (result.code === 'OK' && result.data && result.data.content) {
            setServiceRequests(result.data.content);
        }
        console.log('getListServiceRequests ====', result);
        onShowLoading(false);
    }
    const onClickDetail = async (item) => {
        if (requestDetail && requestDetail.id && item.id === requestDetail.id) {
            onShowDetail(!showDetail);
        }
        else {
            onShowDetail(true);
            setRequestDetail(item)
            await onLoadFiles(item);
        }
    }
    const onCloseAndRefresh = async () => {
        onShowNewServiceRequest(false);
        getListServiceRequests();
    }
    const onLoadFiles = async (service) => {
        onShowLoading(true);
        try {
            let fileExist = files.filter(f => {
                return f.sr_id == service.id;
            })
            if (!fileExist || fileExist.length == 0) {
                var result = await crmservices.config.getListFilesServiceRequest(service.id);
                if (result.code == 'OK') {
                    let _files = [...files];
                    _files.push({ sr_id: service.id, files: result.data.content.length > 0 ? result.data.content : [] })
                    setFiles(_files);
                }
            }
        } catch (error) {
            console.log("load files service request exception:", error);
        }
        onShowLoading(false);
    }
    const get_url_extension = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }
    const onOpenFile = async (file) => {
        console.log("file:", file);
        onShowLoading(true);
        try {
            if (file) {
                let extention = get_url_extension(file.name);
                console.log("extention:", extention);
                var result = await crmservices.config.getDetailFile(file.id);
                if (result.code == 'OK') {
                    let url = window.URL.createObjectURL(result.data);
                    window.open(url, '_blank');
                }
            }
        } catch (error) {
            console.log("load files service request exception:", error);
        }
        onShowLoading(false);
    }
    return (
        <div>
            <ServiceRequestsView
                open={props.open}
                onClose={props.onClose}
                service_request={service_requests}
                showLoading={showLoading}
                showDetail={showDetail}
                transactionDetail={requestDetail}
                files={files}
                onClickDetail={onClickDetail}
                onOpenFile={onOpenFile}
                onLoadFiles={onLoadFiles}
                onShowNewServiceRequest={() => onShowNewServiceRequest(true)} />
            {showNewServiceRequest && <NewServiceRequestController
                open={showNewServiceRequest}
                onClose={() => onShowNewServiceRequest(false)}
                onCloseAndRefresh={onCloseAndRefresh} />
            }
        </div>
    );
}

export default ServiceRequestsController;